module.exports = __webpack_public_path__ + "img/logolhidalgo.d5b0319f.png";